import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3638b34a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3638b34a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638b34a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3638b34a')) {
      api.createRecord('3638b34a', component.options)
    } else {
      api.reload('3638b34a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3638b34a&scoped=true", function () {
      api.rerender('3638b34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/newRole/roleCollapse/index.vue"
export default component.exports